<template>
	<div>
		<j-expendable-box class="bg5 b1 bc7 r2">
			<div slot="header" class="pl3 pr3 pt4 pb4 lh125 fs4 c1 fw7">
				{{ $t("beneficiaries") }}
			</div>
			<beneficiaries-info
				slot="body"
				class="pt2"
				:canWrite="isEditable"
				:list="computedBeneficiariesInfo"
				:showTitle="false"
				@removed="fetchCase"
				@added="fetchCase"
				@updated="fetchCase"
			/>
		</j-expendable-box>
	</div>
</template>

<script>
import BeneficiariesInfo from "./BeneficiariesInfo"
import JExpendableBox from "@/components/JExpendableBox"

export default {
	components: {
		BeneficiariesInfo,
		JExpendableBox
	},

	data() {
		return {
			isEditable: true,
			headline: ""
		}
	},

	computed:{
		computedBeneficiariesInfo() {
			return this.$store.state.caseManagement?.case?.beneficiaryEligibilities
		}
	},

	methods: {
		fetchCase() {
			this.$store.dispatch("caseManagement/fetchCase", {
				caseId: this.$store.state.caseManagement.caseId
			})
		},
	}
}
</script>
